import { Component, ChangeDetectionStrategy } from '@angular/core'
import { RouterLink } from '@angular/router'

@Component({
    selector: 'app-header-public-secondary',
    imports: [RouterLink],
    templateUrl: './header-public-secondary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header-public-secondary.component.scss',
})
export class HeaderPublicSecondaryComponent {}
